import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";
import { FETCH_FEATURE_CREDITS_API } from "features/Account/Account.constants";

export const useCreditDetails = ({ params }) =>
  useCustomQuery({
    url: FETCH_FEATURE_CREDITS_API,
    queryKey: [FETCH_FEATURE_CREDITS_API, params],
    params,
  });
